(function(){
  'use strict';

  const root = document.querySelector('[data-nuvy-bundle]');
  if (!root) return;

  const COLORS = ['Marron', 'Beige', 'Noir'];
  const COLOR_HEX = { Marron: '#8B5E3C', Beige: '#C9A878', Noir: '#1C1C1C' };
  const SIZES = ['S', 'M', 'L', 'XL'];

  let variants = [];
  try {
    variants = JSON.parse(root.querySelector('[data-variants-json]').textContent);
  } catch (e) {
    console.error('[NUVY Bundle] Cannot parse variants', e);
    return;
  }

  function findVariantId(color, size) {
    const found = variants.find(v => v.options && v.options.includes(color) && v.options.includes(size));
    return found ? found.id : null;
  }

  const defaults = {
    pack3: { qty: { Marron: 1, Beige: 1, Noir: 1 }, size: 'S', total: 3, individual: [
      { color: 'Marron', size: 'S' }, { color: 'Beige', size: 'S' }, { color: 'Noir', size: 'S' }
    ]},
    pack5: { qty: { Marron: 1, Beige: 2, Noir: 2 }, size: 'S', total: 5, individual: [
      { color: 'Noir', size: 'S' }, { color: 'Noir', size: 'S' },
      { color: 'Beige', size: 'S' }, { color: 'Beige', size: 'S' },
      { color: 'Marron', size: 'S' }
    ]},
    pack10: { qty: { Marron: 3, Beige: 3, Noir: 4 }, size: 'S', total: 10, individual: (function(){
      const arr = [];
      for (let i=0;i<4;i++) arr.push({color:'Noir',size:'S'});
      for (let i=0;i<3;i++) arr.push({color:'Beige',size:'S'});
      for (let i=0;i<3;i++) arr.push({color:'Marron',size:'S'});
      return arr;
    })()}
  };

  const packPrices = { pack3: '39,80€', pack5: '59,70€', pack10: '99,50€' };
  const packLabels = { pack3: 'ton pack de 3', pack5: 'ton pack de 5', pack10: 'ton pack de 10' };

  let state = {
    view: 'packs',
    currentPack: 'pack5',
    sizeMode: 'uniform',
    selection: JSON.parse(JSON.stringify(defaults)),
    unit: { color: 'Noir', size: 'S' }
  };

  let modalEl = null;
  let modalOpen = false;
  let savedScrollY = 0;

  function ensureModal() {
    if (modalEl) return modalEl;
    const tpl = root.querySelector('[data-modal-template]');
    if (!tpl) return null;
    const clone = tpl.content.firstElementChild.cloneNode(true);
    document.body.appendChild(clone);
    modalEl = clone;
    bindModalEvents(modalEl);
    return modalEl;
  }

  function openModal() {
    const m = ensureModal();
    if (!m) return;
    const sel = state.selection[state.currentPack];
    m.querySelector('[data-modal-pack-name]').textContent = packLabels[state.currentPack];
    m.querySelector('[data-total-required]').textContent = sel.total;
    COLORS.forEach(c => { m.querySelector('[data-qty="' + c + '"]').textContent = sel.qty[c]; });
    updateSizeButtons(sel.size, m);
    updateTotalCount(m);
    setSizeMode(state.sizeMode, m);

    savedScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';

    m.classList.add('nuvy-bundle__modal--open');
    modalOpen = true;
  }

  function closeModal() {
    if (!modalEl || !modalOpen) return;
    modalEl.classList.remove('nuvy-bundle__modal--open');
    modalOpen = false;

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, savedScrollY);
  }

  function bindModalEvents(m) {
    m.querySelectorAll('[data-close-modal]').forEach(b => b.addEventListener('click', closeModal));
    const backdrop = m.querySelector('[data-modal-backdrop]');
    if (backdrop) backdrop.addEventListener('click', closeModal);

    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && modalOpen) closeModal(); });

    m.querySelectorAll('[data-mode]').forEach(btn => btn.addEventListener('click', () => setSizeMode(btn.dataset.mode, m)));

    m.querySelectorAll('[data-uniform-size]').forEach(btn => {
      btn.addEventListener('click', () => {
        const sel = state.selection[state.currentPack];
        sel.size = btn.dataset.uniformSize;
        sel.individual = sel.individual.map(t => ({ color: t.color, size: btn.dataset.uniformSize }));
        updateSizeButtons(btn.dataset.uniformSize, m);
      });
    });

    COLORS.forEach(color => {
      m.querySelector('[data-qty-minus="' + color + '"]').addEventListener('click', () => adjustQty(color, -1, m));
      m.querySelector('[data-qty-plus="' + color + '"]').addEventListener('click', () => adjustQty(color, 1, m));
    });

    m.querySelector('[data-modal-confirm]').addEventListener('click', () => {
      const sel = state.selection[state.currentPack];
      if (state.sizeMode === 'individual') {
        const counts = { Marron: 0, Beige: 0, Noir: 0 };
        sel.individual.forEach(t => counts[t.color]++);
        sel.qty = counts;
      } else {
        const newInd = [];
        COLORS.forEach(c => {
          for (let i = 0; i < sel.qty[c]; i++) newInd.push({ color: c, size: sel.size });
        });
        sel.individual = newInd;
      }
      renderRecap();
      closeModal();
    });
  }

  function setSizeMode(mode, m) {
    state.sizeMode = mode;
    m.querySelectorAll('[data-mode]').forEach(b => b.classList.toggle('nuvy-bundle__mode-tab--active', b.dataset.mode === mode));
    m.querySelectorAll('[data-mode-view]').forEach(v => v.hidden = v.dataset.modeView !== mode);
    m.querySelector('[data-uniform-colors]').hidden = mode !== 'uniform';
    m.querySelector('[data-individual-block]').hidden = mode !== 'individual';
    if (mode === 'individual') {
      renderIndividualRows(m);
      const btn = m.querySelector('[data-modal-confirm]');
      btn.disabled = false;
      btn.textContent = 'Valider ma sélection';
    } else {
      updateTotalCount(m);
    }
  }

  function adjustQty(color, delta, m) {
    const sel = state.selection[state.currentPack];
    const newVal = sel.qty[color] + delta;
    const otherTotal = COLORS.filter(c => c !== color).reduce((s, c) => s + sel.qty[c], 0);
    if (newVal < 0) return;
    if (newVal + otherTotal > sel.total) return;
    sel.qty[color] = newVal;
    m.querySelector('[data-qty="' + color + '"]').textContent = newVal;
    updateTotalCount(m);
  }

  function updateTotalCount(m) {
    const sel = state.selection[state.currentPack];
    const total = COLORS.reduce((s, c) => s + sel.qty[c], 0);
    m.querySelector('[data-total-count]').textContent = total;
    const btn = m.querySelector('[data-modal-confirm]');
    if (total === sel.total) {
      btn.disabled = false;
      btn.textContent = 'Valider ma sélection';
    } else {
      btn.disabled = true;
      btn.textContent = 'Il manque ' + (sel.total - total) + ' tanga(s)';
    }
  }

  function updateSizeButtons(size, m) {
    m.querySelectorAll('[data-uniform-size]').forEach(b => b.classList.toggle('nuvy-bundle__size-btn--selected', b.dataset.uniformSize === size));
  }

  function renderIndividualRows(m) {
    const sel = state.selection[state.currentPack];
    const container = m.querySelector('[data-individual-rows]');
    container.innerHTML = '';
    for (let i = 0; i < sel.total; i++) {
      const tanga = sel.individual[i];
      const row = document.createElement('div');
      row.className = 'nuvy-bundle__individual-row';
      const colorHTML = COLORS.map(c =>
        '<button type="button" class="nuvy-bundle__individual-color-btn ' + (tanga.color === c ? 'nuvy-bundle__individual-color-btn--selected' : '') + '" data-ind-color="' + c + '" data-ind-index="' + i + '">' +
          '<span class="nuvy-bundle__individual-color-dot" style="background:' + COLOR_HEX[c] + '"></span>' +
          '<span>' + c + '</span>' +
        '</button>'
      ).join('');
      const sizeHTML = SIZES.map(s =>
        '<button type="button" class="nuvy-bundle__individual-size-btn ' + (tanga.size === s ? 'nuvy-bundle__individual-size-btn--selected' : '') + '" data-ind-size="' + s + '" data-ind-index="' + i + '">' + s + '</button>'
      ).join('');
      row.innerHTML =
        '<div class="nuvy-bundle__individual-line"><span class="nuvy-bundle__individual-num">#' + (i+1) + '</span><div class="nuvy-bundle__individual-colors">' + colorHTML + '</div></div>' +
        '<div class="nuvy-bundle__individual-line"><span class="nuvy-bundle__individual-num"></span><div class="nuvy-bundle__individual-sizes">' + sizeHTML + '</div></div>';
      container.appendChild(row);
    }
    container.querySelectorAll('[data-ind-color]').forEach(btn => {
      btn.addEventListener('click', () => {
        const i = parseInt(btn.dataset.indIndex);
        sel.individual[i].color = btn.dataset.indColor;
        renderIndividualRows(m);
      });
    });
    container.querySelectorAll('[data-ind-size]').forEach(btn => {
      btn.addEventListener('click', () => {
        const i = parseInt(btn.dataset.indIndex);
        sel.individual[i].size = btn.dataset.indSize;
        renderIndividualRows(m);
      });
    });
  }

  function renderRecap() {
    const sel = state.selection[state.currentPack];
    const container = root.querySelector('[data-recap-items]');
    const allSameSize = sel.individual.every(t => t.size === sel.individual[0].size);
    let html = '';
    if (allSameSize) {
      const items = [];
      COLORS.forEach(c => { if (sel.qty[c] > 0) items.push({color: c, qty: sel.qty[c]}); });
      const sizeLabel = 'taille ' + sel.individual[0].size;
      html = items.map(item =>
        '<div class="nuvy-bundle__recap-item">' +
          '<span class="nuvy-bundle__recap-item-dot" style="background:' + COLOR_HEX[item.color] + '"></span>' +
          '<span>' + item.qty + '× ' + item.color + '</span>' +
          '<span class="nuvy-bundle__recap-item-size">' + sizeLabel + '</span>' +
        '</div>'
      ).join('');
    } else {
      html = sel.individual.map((t, i) =>
        '<div class="nuvy-bundle__recap-item">' +
          '<span style="font-size:11px;color:#6B5448;min-width:18px">#' + (i+1) + '</span>' +
          '<span class="nuvy-bundle__recap-item-dot" style="width:14px;height:14px;background:' + COLOR_HEX[t.color] + '"></span>' +
          '<span>' + t.color + '</span>' +
          '<span class="nuvy-bundle__recap-item-size">taille ' + t.size + '</span>' +
        '</div>'
      ).join('');
    }
    container.innerHTML = html;
  }

  function updateCTA() {
    const label = root.querySelector('[data-cta-label]');
    if (state.view === 'packs') {
      label.textContent = 'AJOUTER AU PANIER · ' + packPrices[state.currentPack];
    } else {
      label.textContent = 'AJOUTER AU PANIER · 19,90€';
    }
  }

  root.querySelectorAll('[data-tab]').forEach(btn => {
    btn.addEventListener('click', () => {
      const tab = btn.dataset.tab;
      state.view = tab;
      root.querySelectorAll('[data-tab]').forEach(b => b.classList.toggle('nuvy-bundle__tab--active', b.dataset.tab === tab));
      root.querySelectorAll('[data-view]').forEach(v => v.hidden = v.dataset.view !== tab);
      const stockBadge = root.querySelector('[data-stock-badge]');
      stockBadge.style.display = tab === 'packs' ? 'flex' : 'none';
      updateCTA();
    });
  });

  root.querySelectorAll('[data-pack]').forEach(card => {
    card.addEventListener('click', () => {
      const pack = card.dataset.pack;
      state.currentPack = pack;
      root.querySelectorAll('[data-pack]').forEach(c => {
        c.classList.remove('nuvy-bundle__pack--selected');
        c.querySelector('.nuvy-bundle__radio').classList.remove('nuvy-bundle__radio--selected');
      });
      card.classList.add('nuvy-bundle__pack--selected');
      card.querySelector('.nuvy-bundle__radio').classList.add('nuvy-bundle__radio--selected');
      root.querySelector('[data-stock-count]').textContent = card.dataset.stock;
      updateCTA();
      renderRecap();
    });
  });

  root.querySelectorAll('[data-unit-color]').forEach(btn => {
    btn.addEventListener('click', () => {
      state.unit.color = btn.dataset.unitColor;
      root.querySelectorAll('[data-unit-color]').forEach(b => b.classList.toggle('nuvy-bundle__swatch--selected', b === btn));
    });
  });
  root.querySelectorAll('[data-unit-size]').forEach(btn => {
    btn.addEventListener('click', () => {
      state.unit.size = btn.dataset.unitSize;
      root.querySelectorAll('[data-unit-size]').forEach(b => b.classList.toggle('nuvy-bundle__size-btn--selected', b === btn));
    });
  });

  root.querySelector('[data-open-modal]').addEventListener('click', openModal);

  const cta = root.querySelector('[data-add-to-cart]');
  cta.addEventListener('click', async () => {
    cta.disabled = true;
    cta.classList.add('nuvy-bundle__cta--loading');
    const label = cta.querySelector('[data-cta-label]');
    const originalLabel = label.textContent;
    label.textContent = 'Ajout au panier...';
    try {
      let itemsToAdd = [];
      if (state.view === 'unit') {
        const vid = findVariantId(state.unit.color, state.unit.size);
        if (!vid) throw new Error('Variante introuvable : ' + state.unit.color + ' / ' + state.unit.size);
        itemsToAdd = [{ id: vid, quantity: 1 }];
      } else {
        const sel = state.selection[state.currentPack];
        const variantMap = {};
        sel.individual.forEach(t => {
          const vid = findVariantId(t.color, t.size);
          if (!vid) throw new Error('Variante introuvable : ' + t.color + ' / ' + t.size);
          variantMap[vid] = (variantMap[vid] || 0) + 1;
        });
        itemsToAdd = Object.keys(variantMap).map(id => ({ id: parseInt(id), quantity: variantMap[id] }));
      }
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Erreur ajout panier');
      }
      window.location.href = '/checkout';
    } catch (e) {
      console.error('[NUVY Bundle] Add to cart failed:', e);
      alert('Erreur : ' + e.message);
      cta.disabled = false;
      cta.classList.remove('nuvy-bundle__cta--loading');
      label.textContent = originalLabel;
    }
  });

  renderRecap();
  updateCTA();
})();
